module.exports = __webpack_public_path__ + "img/index_slogan_bg.8e6f6662.png";